package top.wcpe.allincore.ui.runtime.element

/** modelPreview 动态模板缺少稳定业务键时中止当前候选构建。 */
internal class UnstableModelPreviewKeyException(message: String) : IllegalStateException(message)

/** 为 ModelPreview 生成与作者属性无关的稳定运行时实例键。 */
internal object ModelPreviewInstanceKeys {
    const val EMPTY: String = "P0:D0:"

    fun rootPath(screenId: String, kind: String): String =
        segment("s", screenId) + segment("r", "0") + segment("k", kind)

    fun childPath(parentPath: String, childIndex: Int, kind: String): String =
        parentPath + segment("c", childIndex.toString()) + segment("k", kind)

    fun branchPath(parentPath: String, branchIndex: Int, kind: String): String =
        parentPath + segment("b", branchIndex.toString()) + segment("k", kind)

    fun templatePath(parentPath: String, templateIndex: Int, kind: String): String =
        parentPath + segment("t", templateIndex.toString()) + segment("k", kind)

    fun isStableBusinessKey(value: Any?): Boolean = when (value) {
        is String -> value.isNotEmpty()
        null -> false
        else -> canonicalScalar(value) != null
    }

    fun appendDynamicKey(parentKey: String, value: Any?, fallbackIndex: Int): String {
        val canonical = canonicalScalar(value) ?: segment("i", fallbackIndex.toString())
        return parentKey + segment("d", canonical)
    }

    fun encode(path: String, dynamicKey: String): String =
        "P${path.length}:$path" + "D${dynamicKey.length}:$dynamicKey"

    private fun canonicalScalar(value: Any?): String? = when (value) {
        null -> segment("n", "")
        is String -> segment("s", value)
        is Char -> segment("c", value.toString())
        is Boolean -> segment("b", if (value) "1" else "0")
        is Byte -> segment("y", value.toString())
        is Short -> segment("h", value.toString())
        is Int -> segment("i", value.toString())
        is Long -> segment("l", value.toString())
        is Float -> segment("f", value.toString())
        is Double -> segment("d", value.toString())
        else -> null
    }

    private fun segment(tag: String, value: String): String = "$tag${value.length}:$value"
}
